import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';
import { ShablonConfigDocument, ShablonDocumentOrgFilter } from '@/models/shablon-document.models';

export const shablonService = {

  TypesGet,
  TypesAdminGet,
  TypesAdminAdd,
  TypesAdminEdit,
  TypesAdminDel,
  ShablonGet,
  ShablonFavoritesGet,
  ShablonLastUsedGet,
  ShablonDataGet,
  ShablonAdminGet,
  ShablonAdminDataGet,
  ShablonAdminAdd,
  ShablonAdminImport,
  ShablonAdminCopy,
  ShablonAdminEdit,
  ShablonAdminDel,
  ShablonAdminPublish,
  ShablonAdminPdfGet,
  ShablonAdminUpdateParameters,
  ShablonAdminSettingChange,
  ShablonAdminGenerateTestPdf,
  ShablonAdminAutoFieldGet,
  ShablonAdminDictionaryFieldGet,
  ShablonAdminDictionaryGet,
  ShablonAdminFilesChange,
  ShablonDocumentAdminExport,
  ShablonDictionaryValuesGet,
  ShablonDocumentUserFavoriteGet,
  ShablonDocumentUserFavoriteAdd,
  ShablonDocumentUserFavoriteDel,
  getConfigDocuments
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  }
};

function extract(r) {
  return r.data;
}

async function TypesGet(actualDate) {
  return axios.get(model.baseUrl + 'ShablonDocument/shablon?actualDate=' + actualDate).then(extract);
}

async function TypesAdminGet(actualDate: string, all: number, orgFilter: ShablonDocumentOrgFilter = ShablonDocumentOrgFilter.All) {
  return axios.get(`${model.baseUrl}ShablonDocument/shablonAdmin?actualDate=${actualDate}&all=${all}&orgFilter=${orgFilter}`).then(extract);
}

async function TypesAdminAdd(
  shablonTypeNameUk,
  shablonTypeNameEn,
  shablonTypeCode,
  dateBegin,
  dateEnd,
  shablonTypeDescrUk,
  shablonTypeDescrEn,
  shablonTypeParentId,
  organizationId
) {
  return axios
    .put(model.baseUrl + 'ShablonDocument/shablonAdmin', {
      shablonTypeNameUk: shablonTypeNameUk,
      shablonTypeNameEn: shablonTypeNameEn,
      shablonTypeCode: shablonTypeCode,
      dateBegin: dateBegin,
      dateEnd: dateEnd,
      shablonTypeDescrUk: shablonTypeDescrUk,
      shablonTypeDescrEn: shablonTypeDescrEn,
      shablonTypeParent_Id: shablonTypeParentId,
      organizationId: organizationId
    })
    .then(extract);
}

async function TypesAdminEdit(
  pShablonTypeId,
  shablonTypeNameUk,
  shablonTypeNameEn,
  shablonTypeCode,
  dateBegin,
  dateEnd,
  shablonTypeDescrUk,
  shablonTypeDescrEn,
  shablonTypeParentId) {
  return axios
    .post(model.baseUrl + 'ShablonDocument/shablonAdmin', {
      pShablonType_Id: pShablonTypeId,
      shablonTypeNameUk: shablonTypeNameUk,
      shablonTypeNameEn: shablonTypeNameEn,
      shablonTypeCode: shablonTypeCode,
      dateBegin: dateBegin,
      dateEnd: dateEnd,
      shablonTypeDescrUk: shablonTypeDescrUk,
      shablonTypeDescrEn: shablonTypeDescrEn,
      shablonTypeParent_Id: shablonTypeParentId
    })
    .then(extract);
}

async function TypesAdminDel(pShablonTypeId) {
  return axios
    .delete(model.baseUrl + 'ShablonDocument/shablonAdmin', {
      data: {
        pShablonType_Id: pShablonTypeId
      }
    })
    .then(extract);
}

async function ShablonAdminGet(actualDate, shablonTypeId, all, isEduShablon) {
  return axios
    .get(`${model.baseUrl}ShablonDocument/documentAdmin?actualDate=${actualDate}&shablonTypeId=${shablonTypeId}&all=${all}&isEduShablon=${isEduShablon}`)
    .then(extract);
}

async function ShablonAdminDataGet(ShablonDocumentGUID) {
  return axios.get(model.baseUrl + 'ShablonDocument/documentAdminDataGet?ShablonDocumentGUID=' + ShablonDocumentGUID);
}

async function ShablonAdminAdd(
  shablonTypeId,
  shablonDocumentNameUk,
  shablonDocumentNameEn,
  shablonDocumentDescrUk,
  shablonDocumentDescrEn,
  dateBegin,
  dateEnd,
  shablonDocumentCode,
  shablonDocumentTypeId,
  isDefaultForDocumentType,
  isTemplate,
  isMultiFilesShablon,
  files
) {
  return axios
    .put(model.baseUrl + 'ShablonDocument/documentAdmin', {
      ShablonType_Id: shablonTypeId,
      shablonDocumentNameUk,
      shablonDocumentNameEn,
      shablonDocumentDescrUk,
      shablonDocumentDescrEn,
      dateBegin,
      dateEnd,
      shablonDocumentCode,
      shablonDocumentTypeId,
      isDefaultForDocumentType,
      isTemplate,
      isMultiFilesShablon,
      files
    })
    .then(extract);
}

async function ShablonAdminImport(
  shablonTypeId,
  shablonDocumentNameUk,
  shablonDocumentNameEn,
  shablonDocumentDescrUk,
  shablonDocumentDescrEn,
  dateBegin,
  dateEnd,
  shablonDocumentCode,
  zipBase64,
  shablonDocumentTypeId,
  isDefaultForDocumentType,
  isTemplate
) {
  return axios
    .put(model.baseUrl + 'ShablonDocument/documentImport', {
      ShablonType_Id: shablonTypeId,
      shablonDocumentNameUk,
      shablonDocumentNameEn,
      shablonDocumentDescrUk,
      shablonDocumentDescrEn,
      dateBegin,
      dateEnd,
      shablonDocumentCode,
      zipBase64,
      shablonDocumentTypeId,
      isDefaultForDocumentType,
      isTemplate
    })
    .then(extract);
}

async function ShablonAdminCopy(
  shablonDocumentNameUk,
  shablonDocumentNameEn,
  shablonDocumentDescrUk,
  shablonDocumentDescrEn,
  dateBegin,
  dateEnd,
  sourceShablonDocumentGuid,
  closeSourceDateEnd,
  shablonDocumentTypeId,
  isDefaultForDocumentType
) {
  return axios
    .post(model.baseUrl + 'ShablonDocument/documentAdminCopy', {
      shablonDocumentNameUk,
      shablonDocumentNameEn,
      shablonDocumentDescrUk,
      shablonDocumentDescrEn,
      dateBegin,
      dateEnd,
      sourceShablonDocumentGuid,
      closeSourceDateEnd,
      shablonDocumentTypeId,
      isDefaultForDocumentType
    })
    .then(extract);
}

async function ShablonAdminEdit(
  shablonDocumentId,
  shablonTypeId,
  shablonDocumentNameUk,
  shablonDocumentNameEn,
  shablonDocumentDescrUk,
  shablonDocumentDescrEn,
  dateBegin,
  dateEnd,
  shablonDocumentCode,
  shablonDocumentTypeId,
  isDefaultForDocumentType
) {
  return axios
    .post(model.baseUrl + 'ShablonDocument/documentAdmin', {
      ShablonDocument_Id: shablonDocumentId,
      ShablonType_Id: shablonTypeId,
      shablonDocumentNameUk,
      shablonDocumentNameEn,
      shablonDocumentDescrUk,
      shablonDocumentDescrEn,
      dateBegin,
      dateEnd,
      shablonDocumentCode,
      shablonDocumentTypeId,
      isDefaultForDocumentType
    })
    .then(extract);
}

async function ShablonAdminDel(
  shablonDocumentId
) {
  return axios
    .delete(model.baseUrl + 'ShablonDocument/documentAdmin', {
      data: { ShablonDocument_Id: shablonDocumentId }
    })
    .then(extract);
}

async function ShablonAdminPublish(
  shablonDocumentId,
  isPublic
) {
  return axios
    .post(model.baseUrl + 'ShablonDocument/documentAdminPublish', {
      ShablonDocument_Id: shablonDocumentId,
      IsPublic: isPublic
    })
    .then(extract);
}

async function ShablonAdminSettingChange(
  shablonDocumentGUID,
  configJson
) {
  return axios
    .post(model.baseUrl + 'ShablonDocument/documentAdminSettingCnahges', {
      ShablonDocumentGUID: shablonDocumentGUID,
      ConfigJson: configJson
    })
    .then(extract);
}

async function ShablonAdminPdfGet(fileId: string) {
  return axios.get(model.baseUrl + 'ShablonDocument/documentAdminDownloadPdf?fileId=' + fileId, { responseType: 'blob' });
}

async function ShablonAdminUpdateParameters(shablonDocumentGUID) {
  return axios.post(model.baseUrl + 'ShablonDocument/documentUpdateParameters?shablonDocumentGUID=' + shablonDocumentGUID);
}

async function ShablonAdminGenerateTestPdf(
  shablonDocumentGUID,
  itemsJson
) {
  return axios
    .post(model.baseUrl + 'ShablonDocument/documentAdminGenerateTestPdf', {
      ShablonDocumentGUID: shablonDocumentGUID,
      ItemsJson: itemsJson
    })
    .then(extract);
}

async function ShablonGet() {
  return axios.get(model.baseUrl + 'ShablonDocument').then(extract);
}

async function ShablonFavoritesGet() {
  return axios.get(model.baseUrl + 'ShablonDocument/favorites').then(extract);
}

async function ShablonLastUsedGet() {
  return axios.get(model.baseUrl + 'ShablonDocument/lastUsed').then(extract);
}

async function ShablonDataGet(ShablonDocumentGUID) {
  return axios.get(model.baseUrl + 'ShablonDocument/dataGet?ShablonDocumentGUID=' + ShablonDocumentGUID);
}

async function ShablonAdminAutoFieldGet() {
  return axios.get(model.baseUrl + 'ShablonDocument/documentAdminAutoField').then(extract);
}

async function ShablonAdminDictionaryFieldGet() {
  return axios.get(model.baseUrl + 'ShablonDocument/documentAdminDictionaryField').then(extract);
}

async function ShablonAdminDictionaryGet() {
  return axios.get(model.baseUrl + 'ShablonDocument/documentAdminDictionary').then(extract);
}

async function ShablonDictionaryValuesGet(shablonDictionaryCode) {
  return axios.get(model.baseUrl + 'ShablonDocument/dictionaryValuesGet?shablonDictionaryCode=' + shablonDictionaryCode).then(extract);
}

async function ShablonDocumentUserFavoriteGet() {
  return axios.get(model.baseUrl + 'ShablonDocument/userFavorites').then(extract);
}

async function ShablonDocumentUserFavoriteAdd(
  shablonDocumentCode
) {
  return axios
    .put(model.baseUrl + 'ShablonDocument/userFavorites', {
      ShablonDocumentCode: shablonDocumentCode
    })
    .then(extract);
}

async function ShablonDocumentUserFavoriteDel(shablonDocumentCode) {
  return axios
    .delete(model.baseUrl + 'ShablonDocument/userFavorites', {
      data: {
        ShablonDocumentCode: shablonDocumentCode
      }
    })
    .then(extract);
}

async function ShablonDocumentAdminExport(shablonDocumentGUID) {
  return axios.get(`${model.baseUrl}ShablonDocument/documentAdminExport?shablonDocumentGUID=${shablonDocumentGUID}`,
    { responseType: 'blob' });
}

async function ShablonAdminFilesChange(shablonDocumentGUID, files) {
  return axios.post(model.baseUrl + 'ShablonDocument/documentAdminFilesChange', { shablonDocumentGUID, files });
}

async function getConfigDocuments(shablonDocumentConfigId: number): Promise<Array<ShablonConfigDocument>> {
  let { data } = await axios.get<Array<ShablonConfigDocument>>(
    model.baseUrl + `ShablonDocument/config/${shablonDocumentConfigId}/documents`);

  return data;
}
